module.exports = __webpack_public_path__ + "assets/img/search_ndata.403fecf4.png";